import * as Yup from "yup";

export const distributorSpecialPriceSchema = Yup.object().shape({
  productId: Yup.string().required("Campo requerido"),
  price: Yup.number().required("Campo requerido"),
  effectiveFrom: Yup.date().required("Campo requerido"),
  effectiveTo: Yup.date().nullable(),
});
